module.exports = __webpack_public_path__ + "static/media/matilde-special-indiana-normal.22c4b02a.png";